import React from 'react';
import Icon from '../../../components/AppIcon';

const NotificationFilters = ({ activeFilter, onFilterChange, unreadCount, notifications }) => {
  const filters = [
    {
      id: 'all',
      label: 'All',
      icon: 'Bell',
      count: notifications?.length
    },
    {
      id: 'unread',
      label: 'Unread',
      icon: 'BellDot',
      count: unreadCount
    },
    {
      id: 'deadlines',
      label: 'Deadlines',
      icon: 'Clock',
      count: notifications?.filter(n => n?.type === 'deadline')?.length
    },
    {
      id: 'results',
      label: 'Results',
      icon: 'CheckCircle',
      count: notifications?.filter(n => n?.type === 'result')?.length
    },
    {
      id: 'leaderboard',
      label: 'Leaderboard',
      icon: 'TrendingUp',
      count: notifications?.filter(n => n?.type === 'leaderboard')?.length
    },
    {
      id: 'tournaments',
      label: 'Tournaments',
      icon: 'Trophy',
      count: notifications?.filter(n => n?.type === 'tournament')?.length
    }
  ];

  return (
    <div className="mb-6 md:mb-8">
      {/* Desktop Filters */}
      <div className="hidden md:flex items-center gap-2 bg-card rounded-lg shadow-elevation-sm p-2">
        {filters?.map((filter) => (
          <button
            key={filter?.id}
            onClick={() => onFilterChange(filter?.id)}
            className={`flex items-center gap-2 px-4 py-2.5 rounded-md transition-all duration-200 ${
              activeFilter === filter?.id
                ? 'bg-primary text-primary-foreground shadow-sm'
                : 'text-muted-foreground hover:bg-muted/50 hover:text-foreground'
            }`}
          >
            <Icon name={filter?.icon} size={18} />
            <span className="font-medium">{filter?.label}</span>
            {filter?.count > 0 && (
              <span
                className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
                  activeFilter === filter?.id
                    ? 'bg-primary-foreground/20 text-primary-foreground'
                    : 'bg-muted text-muted-foreground'
                }`}
              >
                {filter?.count}
              </span>
            )}
          </button>
        ))}
      </div>
      {/* Mobile Filters - Horizontal Scroll */}
      <div className="md:hidden overflow-x-auto scrollbar-hide">
        <div className="flex gap-2 pb-2">
          {filters?.map((filter) => (
            <button
              key={filter?.id}
              onClick={() => onFilterChange(filter?.id)}
              className={`flex-shrink-0 flex items-center gap-2 px-4 py-2.5 rounded-lg transition-all duration-200 ${
                activeFilter === filter?.id
                  ? 'bg-primary text-primary-foreground shadow-sm'
                  : 'bg-card text-muted-foreground border border-border hover:border-primary/50'
              }`}
            >
              <Icon name={filter?.icon} size={16} />
              <span className="text-sm font-medium whitespace-nowrap">{filter?.label}</span>
              {filter?.count > 0 && (
                <span
                  className={`px-1.5 py-0.5 rounded-full text-xs font-semibold ${
                    activeFilter === filter?.id
                      ? 'bg-primary-foreground/20 text-primary-foreground'
                      : 'bg-muted text-muted-foreground'
                  }`}
                >
                  {filter?.count}
                </span>
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NotificationFilters;